import React from "react";
import { TrendingUp, Zap, Target } from "lucide-react";

const BRAND_LOGOS = [
  { name: "Acme Corp", logo: "AC" },
  { name: "TechStart", logo: "TS" },
  { name: "DataFlow", logo: "DF" },
  { name: "CloudSync", logo: "CS" },
  { name: "MarketPro", logo: "MP" },
  { name: "SalesHub", logo: "SH" },
  { name: "GrowthLab", logo: "GL" },
  { name: "EmailMax", logo: "EM" },
];

const STATS = [
  {
    icon: Target,
    value: "98%+",
    label: "deliverability achieved on cleaned lists",
    color: "text-sky-600 dark:text-sky-400",
    bgColor: "bg-sky-50 dark:bg-sky-900/20",
  },
  {
    icon: TrendingUp,
    value: "Billions",
    label: "of emails checked per year",
    color: "text-blue-600 dark:text-blue-400",
    bgColor: "bg-blue-50 dark:bg-blue-900/20",
  },
  {
    icon: Zap,
    value: "< 300ms",
    label: "average validation response",
    color: "text-violet-600 dark:text-violet-400",
    bgColor: "bg-violet-50 dark:bg-violet-900/20",
  },
];

export default function TrustSection() {
  return (
    <section className="py-16 lg:py-24 bg-slate-50 dark:bg-slate-900/50 border-y border-slate-200 dark:border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Headline */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 dark:text-slate-50 mb-4">
            Trusted by modern marketing and product teams
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-300 max-w-2xl mx-auto">
            Join thousands of teams who trust VALIDMAIL to keep their email
            lists clean and deliverable
          </p>
        </div>

        {/* Logos Grid */}
        <div className="mb-16">
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-6 lg:gap-8">
            {BRAND_LOGOS.map((brand, index) => (
              <div
                key={index}
                className="flex items-center justify-center p-4 bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 hover:border-sky-300 dark:hover:border-sky-700 transition-all hover:shadow-md group"
              >
                <div className="flex flex-col items-center gap-2">
                  <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-sky-500 to-blue-600 flex items-center justify-center text-white font-bold text-lg group-hover:scale-110 transition-transform">
                    {brand.logo}
                  </div>
                  <span className="text-xs font-medium text-slate-600 dark:text-slate-400">
                    {brand.name}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {STATS.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div
                key={index}
                className="relative group bg-white dark:bg-slate-800 rounded-2xl p-8 border border-slate-200 dark:border-slate-700 hover:border-sky-300 dark:hover:border-sky-700 transition-all hover:shadow-xl"
              >
                {/* Icon */}
                <div
                  className={`inline-flex items-center justify-center w-12 h-12 rounded-xl ${stat.bgColor} mb-4 group-hover:scale-110 transition-transform`}
                >
                  <Icon className={`h-6 w-6 ${stat.color}`} />
                </div>

                {/* Value */}
                <div className="mb-2">
                  <span className="text-4xl lg:text-5xl font-bold text-slate-900 dark:text-slate-50">
                    {stat.value}
                  </span>
                </div>

                {/* Label */}
                <p className="text-slate-600 dark:text-slate-300 leading-relaxed">
                  {stat.label}
                </p>

                {/* Decorative gradient */}
                <div
                  className={`absolute inset-0 ${stat.bgColor} opacity-0 group-hover:opacity-5 rounded-2xl transition-opacity`}
                />
              </div>
            );
          })}
        </div>

        {/* Mobile horizontal scroll hint */}
        <div className="mt-8 text-center md:hidden">
          <p className="text-sm text-slate-500 dark:text-slate-400">
            ← Scroll to see all stats →
          </p>
        </div>
      </div>
    </section>
  );
}
